// Join optional strings together, filtering empty values
// especially useful when passing optional className props around
export const concatStringish = (...things: (string | undefined)[]): string =>
  things.filter(x => !!x).join(' ');
